import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

// Country - Get All
export const AppSetup = createAsyncThunk(
  "common/masters/appsetup",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AppSetup}?name=${filter}`);
      return res.data;
      // return await Select2Data(res.data, "volunteer_detail_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    all_appsetup: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete

      .addCase(AppSetup.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AppSetup.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_appsetup = action.payload || [];
      })
      .addCase(AppSetup.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
